module.exports = __webpack_public_path__ + "img/ring_y_i_0_0@2x.adc1392c.png";